import React from 'react'
import { useSelector } from 'react-redux'
import { withStyles } from '@mui/styles'
import { Switch } from '@mui/material'

const switchStyles = (theme) => ({
  root: {
    marginRight: 10,
  },
  switchBase: {
    '&$checked': {
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  track: {
    backgroundColor: theme.palette.grey[500],
  },
  checked: {},
})

export const TableActions = withStyles(switchStyles)(({ classes, row }) => {
  const global = useSelector((state) => state.global)
  const switchDisabled = '' + row.original.id === global.user_id
  const userState = row.original['activo']

  return (
    <Switch
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        track: classes.track,
        checked: classes.checked,
      }}
      checked={userState}
      disabled={switchDisabled}
    />
  )
})
